function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#kayak_svg__clip0_7017_33028)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 .93h31.218v31.217H0V.93z",
  fill: "#FF690F"
}), /*#__PURE__*/React.createElement("path", {
  d: "M9.624 8.741h3.794v15.61H9.624V8.74z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  d: "M21.594 24.337h-4.186l-4.316-7.798 4.316-7.798h4.186l-4.342 7.798 4.342 7.798z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  d: "M32.952.93H64.17v31.217H32.952V.93z",
  fill: "#FF690F"
}), /*#__PURE__*/React.createElement("path", {
  d: "M45.731 22.094l-.678 2.269h-4.042l5.137-15.648h4.825l5.099 15.648h-4.134l-.678-2.243-5.529-.026zm2.765-8.893l-1.826 5.828h3.651l-1.825-5.828z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  d: "M65.891.93H97.11v31.217H65.89V.93z",
  fill: "#FF690F"
}), /*#__PURE__*/React.createElement("path", {
  d: "M83.456 24.363h-3.821v-6.898l-5.125-8.75h4.512l2.53 4.799 2.49-4.8h4.447l-5.033 8.75v6.899z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  d: "M98.843.93h31.218v31.217H98.843V.93z",
  fill: "#FF690F"
}), /*#__PURE__*/React.createElement("path", {
  d: "M111.622 22.094l-.678 2.269h-4.042l5.138-15.648h4.824l5.099 15.648h-4.134l-.678-2.243-5.529-.026zm2.765-8.893l-1.826 5.828h3.651l-1.825-5.828z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  d: "M131.782.93H163v31.217h-31.218V.93z",
  fill: "#FF690F"
}), /*#__PURE__*/React.createElement("path", {
  d: "M141.406 8.741h3.794v15.61h-3.794V8.74z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  d: "M153.377 24.337h-4.186l-4.316-7.798 4.316-7.798h4.186l-4.343 7.798 4.343 7.798z",
  fill: "#fff"
}));

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "kayak_svg__clip0_7017_33028"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  transform: "translate(0 .93)",
  d: "M0 0h163v31.218H0z"
})));

function SvgKayak(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 163,
    height: 33,
    viewBox: "0 0 163 33",
    fill: "none"
  }, props), _ref, _ref2);
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYzIiBoZWlnaHQ9IjMzIiB2aWV3Qm94PSIwIDAgMTYzIDMzIiBmaWxsPSJub25lIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPgo8ZyBjbGlwLXBhdGg9InVybCgjY2xpcDBfNzAxN18zMzAyOCkiPgo8cGF0aCBkPSJNMCAwLjkyOTY4OEgzMS4yMTc3VjMyLjE0NzRIMFYwLjkyOTY4OFoiIGZpbGw9IiNGRjY5MEYiLz4KPHBhdGggZD0iTTkuNjIzNTQgOC43NDEyMUgxMy40MTgyVjI0LjM1MDFIOS42MjM1NFY4Ljc0MTIxWiIgZmlsbD0id2hpdGUiLz4KPHBhdGggZD0iTTIxLjU5NDQgMjQuMzM3SDE3LjQwODVMMTMuMDkyMyAxNi41MzkxTDE3LjQwODUgOC43NDEyMUgyMS41OTQ0TDE3LjI1MiAxNi41MzkxTDIxLjU5NDQgMjQuMzM3WiIgZmlsbD0id2hpdGUiLz4KPHBhdGggZD0iTTMyLjk1MjEgMC45Mjk2ODhINjQuMTY5OVYzMi4xNDc0SDMyLjk1MjFWMC45Mjk2ODhaIiBmaWxsPSIjRkY2OTBGIi8+CjxwYXRoIGQ9Ik00NS43MzEyIDIyLjA5MzlMNDUuMDUzMSAyNC4zNjI4SDQxLjAxMDdMNDYuMTQ4NSA4LjcxNDg0SDUwLjk3MzNMNTYuMDcxOSAyNC4zNjI4SDUxLjkzODNMNTEuMjYwMiAyMi4xMkw0NS43MzEyIDIyLjA5MzlaTTQ4LjQ5NTcgMTMuMjAwNkw0Ni42NzAxIDE5LjAyOTVINTAuMzIxM0w0OC40OTU3IDEzLjIwMDZaIiBmaWxsPSJ3aGl0ZSIvPgo8cGF0aCBkPSJNNjUuODkxMSAwLjkyOTY4OEg5Ny4xMDg5VjMyLjE0NzRINjUuODkxMVYwLjkyOTY4OFoiIGZpbGw9IiNGRjY5MEYiLz4KPHBhdGggZD0iTTgzLjQ1NTcgMjQuMzYyOEg3OS42MzVWMTcuNDY0N0w3NC41MTAzIDguNzE0ODRINzkuMDIyMUw4MS41NTE4IDEzLjUxMzZMODQuMDQyNSA4LjcxNDg0SDg4LjQ4OTFMODMuNDU1NyAxNy40NjQ3VjI0LjM2MjhaIiBmaWxsPSJ3aGl0ZSIvPgo8cGF0aCBkPSJNOTguODQzMyAwLjkyOTY4OEgxMzAuMDYxVjMyLjE0NzRIOTguODQzM1YwLjkyOTY4OFoiIGZpbGw9IiNGRjY5MEYiLz4KPHBhdGggZD0iTTExMS42MjIgMjIuMDkzOUwxMTAuOTQ0IDI0LjM2MjhIMTA2LjkwMkwxMTIuMDQgOC43MTQ4NEgxMTYuODY0TDEyMS45NjMgMjQuMzYyOEgxMTcuODI5TDExNy4xNTEgMjIuMTJMMTExLjYyMiAyMi4wOTM5Wk0xMTQuMzg3IDEzLjIwMDZMMTEyLjU2MSAxOS4wMjk1SDExNi4yMTJMMTE0LjM4NyAxMy4yMDA2WiIgZmlsbD0id2hpdGUiLz4KPHBhdGggZD0iTTEzMS43ODIgMC45Mjk2ODhIMTYzVjMyLjE0NzRIMTMxLjc4MlYwLjkyOTY4OFoiIGZpbGw9IiNGRjY5MEYiLz4KPHBhdGggZD0iTTE0MS40MDYgOC43NDEyMUgxNDUuMlYyNC4zNTAxSDE0MS40MDZWOC43NDEyMVoiIGZpbGw9IndoaXRlIi8+CjxwYXRoIGQ9Ik0xNTMuMzc3IDI0LjMzN0gxNDkuMTkxTDE0NC44NzUgMTYuNTM5MUwxNDkuMTkxIDguNzQxMjFIMTUzLjM3N0wxNDkuMDM0IDE2LjUzOTFMMTUzLjM3NyAyNC4zMzdaIiBmaWxsPSJ3aGl0ZSIvPgo8L2c+CjxkZWZzPgo8Y2xpcFBhdGggaWQ9ImNsaXAwXzcwMTdfMzMwMjgiPgo8cmVjdCB3aWR0aD0iMTYzIiBoZWlnaHQ9IjMxLjIxNzgiIGZpbGw9IndoaXRlIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgwIDAuOTI5Njg4KSIvPgo8L2NsaXBQYXRoPgo8L2RlZnM+Cjwvc3ZnPgo=";
export { SvgKayak as ReactComponent };